export const ROUTE_PATH = '/kkms/:kkmId';
